// src/components/Icon.tsx

import React from 'react';
import { ICON_SIZES, IconSize } from '../../constants/ui';

// Standard Icon Imports
import { ReactComponent as AddDownIcon } from './AddDownIcon.svg';
import { ReactComponent as AddIcon } from './AddIcon.svg';
import { ReactComponent as AddUpIcon } from './AddUpIcon.svg';
import { ReactComponent as AgeDownIcon } from './AgeDownIcon.svg';
import { ReactComponent as AgeIcon } from './AgeIcon.svg';
import { ReactComponent as AgeUpIcon } from './AgeUpIcon.svg';
import { ReactComponent as AnalyseUpIcon } from './AnalyseUpIcon.svg';
import { ReactComponent as CancelIcon } from './CancelIcon.svg';
import { ReactComponent as CancelUpIcon } from './CancelUpIcon.svg';
import { ReactComponent as ChevronBackUpIcon } from './ChevronBackUpIcon.svg';
import { ReactComponent as CityIcon } from './CityIcon.svg';
import { ReactComponent as DeleteIcon } from './DeleteIcon.svg';
import { ReactComponent as DeleteUpIcon } from './DeleteUpIcon.svg';
import { ReactComponent as FilterDownIcon } from './FilterDownIcon.svg';
import { ReactComponent as FilterUpIcon } from './FilterUpIcon.svg';
import { ReactComponent as FreakConnectDownIcon } from './FreakConnectDownIcon.svg';
import { ReactComponent as FreakConnectUpIcon } from './FreakConnectUpIcon.svg';
import { ReactComponent as FreakSearchDownIcon } from './FreakSearchDownIcon.svg';
import { ReactComponent as FreakSearchUpIcon } from './FreakSearchUpIcon.svg';
import { ReactComponent as FriendsIcon } from './FriendsIcon.svg';
import { ReactComponent as HotSpotMapIcon } from './HotSpotMapIcon.svg';
import { ReactComponent as InfoUpIcon } from './InfoUpIcon.svg';
import { ReactComponent as JoinIcon } from './JoinIcon.svg';
import { ReactComponent as JoinUpIcon } from './JoinUpIcon.svg';
import { ReactComponent as JudgeIcon } from './JudgeIcon.svg';
import { ReactComponent as JudgeUpIcon } from './JudgeUpIcon.svg';
import { ReactComponent as LeaveDownIcon } from './LeaveDownIcon.svg';
import { ReactComponent as LeaveIcon } from './LeaveIcon.svg';
import { ReactComponent as LocationIcon } from './LocationIcon.svg';
import { ReactComponent as NationalityDownIcon } from './NationalityDownIcon.svg';
import { ReactComponent as NationalityIcon } from './NationalityIcon.svg';
import { ReactComponent as NationalityIcon_black } from './NationalityIcon_black.svg';
import { ReactComponent as NationalityUpIcon } from './NationalityUpIcon.svg';
import { ReactComponent as OKIcon } from './OKIcon.svg';
import { ReactComponent as OKUpIcon } from './OKUpIcon.svg';
import { ReactComponent as ParkMapIcon } from './ParkMapIcon.svg';
import { ReactComponent as PersonIroIcon } from './PersonIroIcon.svg';
import { ReactComponent as PlayMapIcon } from './PlayMapIcon.svg';
import { ReactComponent as RallySign } from './RallySign.svg';
import { ReactComponent as RankingIcon } from './RankingIcon.svg';
import { ReactComponent as ShareIcon } from './ShareIcon.svg';
import { ReactComponent as ShareUpIcon } from './ShareUpIcon.svg';
import { ReactComponent as ShareVideoUpIcon } from './ShareVideoUpIcon.svg';
import { ReactComponent as ShopIcon } from './ShopIcon.svg';
import { ReactComponent as SingerSidedHairIcon } from './SingerSidedHairIcon.svg';
import { ReactComponent as SpikeIcon } from './SpikeIcon.svg';
import { ReactComponent as TelemetrieDownIcon } from './TelemetrieDownIcon.svg';
import { ReactComponent as TestIcon } from './TestIcon.svg';
import { ReactComponent as ToolUpIcon } from './ToolUpIcon.svg';
import { ReactComponent as Ufo_Score } from './Ufo_Score.svg';
import { ReactComponent as WinnerSidedHairIcon } from './WinnerSidedHairIcon.svg';
import { ReactComponent as WorldDownIcon } from './WorldDownIcon.svg';
import { ReactComponent as WorldIcon } from './WorldIcon.svg';
import { ReactComponent as WorldIcon_black } from './WorldIcon_black.svg';
import { ReactComponent as WorldUpIcon } from './WorldUpIcon.svg';
import { ReactComponent as Wow } from './Wow.svg';

// Flaggen Imports
import { ReactComponent as AD } from '../flags/AD.svg';
import { ReactComponent as AE } from '../flags/AE.svg';
import { ReactComponent as AF } from '../flags/AF.svg';
import { ReactComponent as AG } from '../flags/AG.svg';
import { ReactComponent as AI } from '../flags/AI.svg';
import { ReactComponent as AL } from '../flags/AL.svg';
import { ReactComponent as AM } from '../flags/AM.svg';
import { ReactComponent as AO } from '../flags/AO.svg';
import { ReactComponent as AQ } from '../flags/AQ.svg';
import { ReactComponent as AR } from '../flags/AR.svg';
import { ReactComponent as AS } from '../flags/AS.svg';
import { ReactComponent as AT } from '../flags/AT.svg';
import { ReactComponent as AU } from '../flags/AU.svg';
import { ReactComponent as AW } from '../flags/AW.svg';
import { ReactComponent as AX } from '../flags/AX.svg';
import { ReactComponent as AZ } from '../flags/AZ.svg';
import { ReactComponent as BA } from '../flags/BA.svg';
import { ReactComponent as BB } from '../flags/BB.svg';
import { ReactComponent as BD } from '../flags/BD.svg';
import { ReactComponent as BE } from '../flags/BE.svg';
import { ReactComponent as BF } from '../flags/BF.svg';
import { ReactComponent as BG } from '../flags/BG.svg';
import { ReactComponent as BH } from '../flags/BH.svg';
import { ReactComponent as BI } from '../flags/BI.svg';
import { ReactComponent as BJ } from '../flags/BJ.svg';
import { ReactComponent as BL } from '../flags/BL.svg';
import { ReactComponent as BM } from '../flags/BM.svg';
import { ReactComponent as BN } from '../flags/BN.svg';
import { ReactComponent as BO } from '../flags/BO.svg';
import { ReactComponent as BQ } from '../flags/BQ.svg';
import { ReactComponent as BR } from '../flags/BR.svg';
import { ReactComponent as BS } from '../flags/BS.svg';
import { ReactComponent as BT } from '../flags/BT.svg';
import { ReactComponent as BV } from '../flags/BV.svg';
import { ReactComponent as BW } from '../flags/BW.svg';
import { ReactComponent as BY } from '../flags/BY.svg';
import { ReactComponent as BZ } from '../flags/BZ.svg';
import { ReactComponent as CA } from '../flags/CA.svg';
import { ReactComponent as CC } from '../flags/CC.svg';
import { ReactComponent as CD } from '../flags/CD.svg';
import { ReactComponent as CF } from '../flags/CF.svg';
import { ReactComponent as CG } from '../flags/CG.svg';
import { ReactComponent as CH } from '../flags/CH.svg';
import { ReactComponent as CI } from '../flags/CI.svg';
import { ReactComponent as CK } from '../flags/CK.svg';
import { ReactComponent as CL } from '../flags/CL.svg';
import { ReactComponent as CM } from '../flags/CM.svg';
import { ReactComponent as CN } from '../flags/CN.svg';
import { ReactComponent as CO } from '../flags/CO.svg';
import { ReactComponent as CR } from '../flags/CR.svg';
import { ReactComponent as CU } from '../flags/CU.svg';
import { ReactComponent as CV } from '../flags/CV.svg';
import { ReactComponent as CW } from '../flags/CW.svg';
import { ReactComponent as CX } from '../flags/CX.svg';
import { ReactComponent as CY } from '../flags/CY.svg';
import { ReactComponent as CZ } from '../flags/CZ.svg';
import { ReactComponent as DE } from '../flags/DE.svg';
import { ReactComponent as DJ } from '../flags/DJ.svg';
import { ReactComponent as DK } from '../flags/DK.svg';
import { ReactComponent as DM } from '../flags/DM.svg';
import { ReactComponent as DO } from '../flags/DO.svg';
import { ReactComponent as DZ } from '../flags/DZ.svg';
import { ReactComponent as EC } from '../flags/EC.svg';
import { ReactComponent as EE } from '../flags/EE.svg';
import { ReactComponent as EG } from '../flags/EG.svg';
import { ReactComponent as EH } from '../flags/EH.svg';
import { ReactComponent as ER } from '../flags/ER.svg';
import { ReactComponent as ES } from '../flags/ES.svg';
import { ReactComponent as ET } from '../flags/ET.svg';
import { ReactComponent as FI } from '../flags/FI.svg';
import { ReactComponent as FJ } from '../flags/FJ.svg';
import { ReactComponent as FK } from '../flags/FK.svg';
import { ReactComponent as FM } from '../flags/FM.svg';
import { ReactComponent as FO } from '../flags/FO.svg';
import { ReactComponent as FR } from '../flags/FR.svg';
import { ReactComponent as GA } from '../flags/GA.svg';
import { ReactComponent as GB } from '../flags/GB.svg';
import { ReactComponent as GD } from '../flags/GD.svg';
import { ReactComponent as GE } from '../flags/GE.svg';
import { ReactComponent as GF } from '../flags/GF.svg';
import { ReactComponent as GG } from '../flags/GG.svg';
import { ReactComponent as GH } from '../flags/GH.svg';
import { ReactComponent as GI } from '../flags/GI.svg';
import { ReactComponent as GL } from '../flags/GL.svg';
import { ReactComponent as GM } from '../flags/GM.svg';
import { ReactComponent as GN } from '../flags/GN.svg';
import { ReactComponent as GP } from '../flags/GP.svg';
import { ReactComponent as GQ } from '../flags/GQ.svg';
import { ReactComponent as GR } from '../flags/GR.svg';
import { ReactComponent as GS } from '../flags/GS.svg';
import { ReactComponent as GT } from '../flags/GT.svg';
import { ReactComponent as GU } from '../flags/GU.svg';
import { ReactComponent as GW } from '../flags/GW.svg';
import { ReactComponent as GY } from '../flags/GY.svg';
import { ReactComponent as HK } from '../flags/HK.svg';
import { ReactComponent as HM } from '../flags/HM.svg';
import { ReactComponent as HN } from '../flags/HN.svg';
import { ReactComponent as HR } from '../flags/HR.svg';
import { ReactComponent as HT } from '../flags/HT.svg';
import { ReactComponent as HU } from '../flags/HU.svg';
import { ReactComponent as ID } from '../flags/ID.svg';
import { ReactComponent as IE } from '../flags/IE.svg';
import { ReactComponent as IL } from '../flags/IL.svg';
import { ReactComponent as IM } from '../flags/IM.svg';
import { ReactComponent as IN } from '../flags/IN.svg';
import { ReactComponent as IO } from '../flags/IO.svg';
import { ReactComponent as IQ } from '../flags/IQ.svg';
import { ReactComponent as IR } from '../flags/IR.svg';
import { ReactComponent as IS } from '../flags/IS.svg';
import { ReactComponent as IT } from '../flags/IT.svg';
import { ReactComponent as JE } from '../flags/JE.svg';
import { ReactComponent as JM } from '../flags/JM.svg';
import { ReactComponent as JO } from '../flags/JO.svg';
import { ReactComponent as JP } from '../flags/JP.svg';
import { ReactComponent as KE } from '../flags/KE.svg';
import { ReactComponent as KG } from '../flags/KG.svg';
import { ReactComponent as KH } from '../flags/KH.svg';
import { ReactComponent as KI } from '../flags/KI.svg';
import { ReactComponent as KM } from '../flags/KM.svg';
import { ReactComponent as KN } from '../flags/KN.svg';
import { ReactComponent as KP } from '../flags/KP.svg';
import { ReactComponent as KR } from '../flags/KR.svg';
import { ReactComponent as KW } from '../flags/KW.svg';
import { ReactComponent as KY } from '../flags/KY.svg';
import { ReactComponent as KZ } from '../flags/KZ.svg';
import { ReactComponent as LA } from '../flags/LA.svg';
import { ReactComponent as LB } from '../flags/LB.svg';
import { ReactComponent as LC } from '../flags/LC.svg';
import { ReactComponent as LI } from '../flags/LI.svg';
import { ReactComponent as LK } from '../flags/LK.svg';
import { ReactComponent as LR } from '../flags/LR.svg';
import { ReactComponent as LS } from '../flags/LS.svg';
import { ReactComponent as LT } from '../flags/LT.svg';
import { ReactComponent as LU } from '../flags/LU.svg';
import { ReactComponent as LV } from '../flags/LV.svg';
import { ReactComponent as LY } from '../flags/LY.svg';
import { ReactComponent as MA } from '../flags/MA.svg';
import { ReactComponent as MC } from '../flags/MC.svg';
import { ReactComponent as MD } from '../flags/MD.svg';
import { ReactComponent as ME } from '../flags/ME.svg';
import { ReactComponent as MF } from '../flags/MF.svg';
import { ReactComponent as MG } from '../flags/MG.svg';
import { ReactComponent as MH } from '../flags/MH.svg';
import { ReactComponent as MK } from '../flags/MK.svg';
import { ReactComponent as ML } from '../flags/ML.svg';
import { ReactComponent as MM } from '../flags/MM.svg';
import { ReactComponent as MN } from '../flags/MN.svg';
import { ReactComponent as MO } from '../flags/MO.svg';
import { ReactComponent as MP } from '../flags/MP.svg';
import { ReactComponent as MQ } from '../flags/MQ.svg';
import { ReactComponent as MR } from '../flags/MR.svg';
import { ReactComponent as MS } from '../flags/MS.svg';
import { ReactComponent as MT } from '../flags/MT.svg';
import { ReactComponent as MU } from '../flags/MU.svg';
import { ReactComponent as MV } from '../flags/MV.svg';
import { ReactComponent as MW } from '../flags/MW.svg';
import { ReactComponent as MX } from '../flags/MX.svg';
import { ReactComponent as MY } from '../flags/MY.svg';
import { ReactComponent as MZ } from '../flags/MZ.svg';
import { ReactComponent as NA } from '../flags/NA.svg';
import { ReactComponent as NC } from '../flags/NC.svg';
import { ReactComponent as NE } from '../flags/NE.svg';
import { ReactComponent as NF } from '../flags/NF.svg';
import { ReactComponent as NG } from '../flags/NG.svg';
import { ReactComponent as NI } from '../flags/NI.svg';
import { ReactComponent as NL } from '../flags/NL.svg';
import { ReactComponent as NO } from '../flags/NO.svg';
import { ReactComponent as NP } from '../flags/NP.svg';
import { ReactComponent as NR } from '../flags/NR.svg';
import { ReactComponent as NU } from '../flags/NU.svg';
import { ReactComponent as NZ } from '../flags/NZ.svg';
import { ReactComponent as OM } from '../flags/OM.svg';
import { ReactComponent as PA } from '../flags/PA.svg';
import { ReactComponent as PE } from '../flags/PE.svg';
import { ReactComponent as PF } from '../flags/PF.svg';
import { ReactComponent as PG } from '../flags/PG.svg';
import { ReactComponent as PH } from '../flags/PH.svg';
import { ReactComponent as PK } from '../flags/PK.svg';
import { ReactComponent as PL } from '../flags/PL.svg';
import { ReactComponent as PM } from '../flags/PM.svg';
import { ReactComponent as PN } from '../flags/PN.svg';
import { ReactComponent as PR } from '../flags/PR.svg';
import { ReactComponent as PS } from '../flags/PS.svg';
import { ReactComponent as PT } from '../flags/PT.svg';
import { ReactComponent as PW } from '../flags/PW.svg';
import { ReactComponent as PY } from '../flags/PY.svg';
import { ReactComponent as QA } from '../flags/QA.svg';
import { ReactComponent as RE } from '../flags/RE.svg';
import { ReactComponent as RO } from '../flags/RO.svg';
import { ReactComponent as RS } from '../flags/RS.svg';
import { ReactComponent as RU } from '../flags/RU.svg';
import { ReactComponent as RW } from '../flags/RW.svg';
import { ReactComponent as SA } from '../flags/SA.svg';
import { ReactComponent as SB } from '../flags/SB.svg';
import { ReactComponent as SC } from '../flags/SC.svg';
import { ReactComponent as SD } from '../flags/SD.svg';
import { ReactComponent as SE } from '../flags/SE.svg';
import { ReactComponent as SG } from '../flags/SG.svg';
import { ReactComponent as SH } from '../flags/SH.svg';
import { ReactComponent as SI } from '../flags/SI.svg';
import { ReactComponent as SJ } from '../flags/SJ.svg';
import { ReactComponent as SK } from '../flags/SK.svg';
import { ReactComponent as SL } from '../flags/SL.svg';
import { ReactComponent as SM } from '../flags/SM.svg';
import { ReactComponent as SN } from '../flags/SN.svg';
import { ReactComponent as SO } from '../flags/SO.svg';
import { ReactComponent as SR } from '../flags/SR.svg';
import { ReactComponent as SS } from '../flags/SS.svg';
import { ReactComponent as ST } from '../flags/ST.svg';
import { ReactComponent as SV } from '../flags/SV.svg';
import { ReactComponent as SX } from '../flags/SX.svg';
import { ReactComponent as SY } from '../flags/SY.svg';
import { ReactComponent as SZ } from '../flags/SZ.svg';
import { ReactComponent as TC } from '../flags/TC.svg';
import { ReactComponent as TD } from '../flags/TD.svg';
import { ReactComponent as TF } from '../flags/TF.svg';
import { ReactComponent as TG } from '../flags/TG.svg';
import { ReactComponent as TH } from '../flags/TH.svg';
import { ReactComponent as TJ } from '../flags/TJ.svg';
import { ReactComponent as TK } from '../flags/TK.svg';
import { ReactComponent as TL } from '../flags/TL.svg';
import { ReactComponent as TM } from '../flags/TM.svg';
import { ReactComponent as TN } from '../flags/TN.svg';
import { ReactComponent as TO } from '../flags/TO.svg';
import { ReactComponent as TR } from '../flags/TR.svg';
import { ReactComponent as TT } from '../flags/TT.svg';
import { ReactComponent as TV } from '../flags/TV.svg';
import { ReactComponent as TW } from '../flags/TW.svg';
import { ReactComponent as TZ } from '../flags/TZ.svg';
import { ReactComponent as UA } from '../flags/UA.svg';
import { ReactComponent as UG } from '../flags/UG.svg';
import { ReactComponent as UM } from '../flags/UM.svg';
import { ReactComponent as US } from '../flags/US.svg';
import { ReactComponent as UY } from '../flags/UY.svg';
import { ReactComponent as UZ } from '../flags/UZ.svg';
import { ReactComponent as VA } from '../flags/VA.svg';
import { ReactComponent as VC } from '../flags/VC.svg';
import { ReactComponent as VE } from '../flags/VE.svg';
import { ReactComponent as VG } from '../flags/VG.svg';
import { ReactComponent as VI } from '../flags/VI.svg';
import { ReactComponent as VN } from '../flags/VN.svg';
import { ReactComponent as VU } from '../flags/VU.svg';
import { ReactComponent as WF } from '../flags/WF.svg';
import { ReactComponent as WS } from '../flags/WS.svg';
import { ReactComponent as XK } from '../flags/XK.svg';
import { ReactComponent as YE } from '../flags/YE.svg';
import { ReactComponent as YT } from '../flags/YT.svg';
import { ReactComponent as ZA } from '../flags/ZA.svg';
import { ReactComponent as ZM } from '../flags/ZM.svg';
import { ReactComponent as ZW } from '../flags/ZW.svg';

// Kontinente Imports
import { ReactComponent as AFR } from '../continents/AFR.svg';
import { ReactComponent as ASI } from '../continents/ASI.svg';
import { ReactComponent as AUS } from '../continents/AUS.svg';
import { ReactComponent as EUR } from '../continents/EUR.svg';
import { ReactComponent as NAM } from '../continents/NAM.svg';
import { ReactComponent as SAM } from '../continents/SAM.svg';
import { logger } from 'services/Logger';

type IconMargin = 'default' | 'none' | 'small' | 'medium' | 'large';

const ICON_MARGIN: Record<IconMargin, string> = {
  default: '0',
  none: '0',
  small: '2px',
  medium: '6px',
  large: '12px',
};

interface IconProps {
  name: string; // z. B. "CancelIcon", "TestIcon"
  size?: IconSize | number | string; // Standard-Größen oder individuelle px/rem/em Werte
  color?: string; // Optional, kein Standardwert
  className?: string;
  
  // Margin-Eigenschaften
  margin?: IconMargin | string | number; // Alle Seiten
  marginTop?: string | number;
  marginRight?: string | number;
  marginBottom?: string | number;
  marginLeft?: string | number;
  
  // Padding-Eigenschaften
  padding?: string | number; // Alle Seiten
  paddingTop?: string | number;
  paddingRight?: string | number;
  paddingBottom?: string | number;
  paddingLeft?: string | number;
  
  style?: React.CSSProperties; // Zusätzliche CSS-Styles
  onClick?: (event: React.MouseEvent<SVGSVGElement>) => void; // Optional: Click-Handler
}

// Mapping der verfügbaren Icons
const ICON_COMPONENTS: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  // Standard Icons
  AddDownIcon,
  AddIcon,
  AddUpIcon,
  AgeDownIcon,
  AgeIcon,
  AgeUpIcon,
  AnalyseUpIcon,
  CancelIcon,
  CancelUpIcon,
  ChevronBackUpIcon,
  CityIcon,
  DeleteIcon,
  DeleteUpIcon,
  FilterDownIcon,
  FilterUpIcon,
  FreakConnectDownIcon,
  FreakConnectUpIcon,
  FreakSearchDownIcon,
  FreakSearchUpIcon,
  FriendsIcon,
  HotSpotMapIcon,
  InfoUpIcon,
  JoinIcon,
  JoinUpIcon,
  JudgeIcon,
  JudgeUpIcon,
  LeaveDownIcon,
  LeaveIcon,
  LocationIcon,
  NationalityDownIcon,
  NationalityIcon,
  NationalityIcon_black,
  NationalityUpIcon,
  OKIcon,
  OKUpIcon,
  ParkMapIcon,
  PersonIroIcon,
  PlayMapIcon,
  RallySign,
  RankingIcon,
  ShareIcon,
  ShareUpIcon,
  ShareVideoUpIcon,
  ShopIcon,
  SingerSidedHairIcon,
  SpikeIcon,
  TelemetrieDownIcon,
  TestIcon,
  ToolUpIcon,
  Ufo_Score,
  WinnerSidedHairIcon,
  WorldDownIcon,
  WorldIcon,
  WorldIcon_black,
  WorldUpIcon,
  Wow,

  // Flaggen
  AD,
  AE,
  AF,
  AG,
  AI,
  AL,
  AM,
  AO,
  AQ,
  AR,
  AS,
  AT,
  AU,
  AW,
  AX,
  AZ,
  BA,
  BB,
  BD,
  BE,
  BF,
  BG,
  BH,
  BI,
  BJ,
  BL,
  BM,
  BN,
  BO,
  BQ,
  BR,
  BS,
  BT,
  BV,
  BW,
  BY,
  BZ,
  CA,
  CC,
  CD,
  CF,
  CG,
  CH,
  CI,
  CK,
  CL,
  CM,
  CN,
  CO,
  CR,
  CU,
  CV,
  CW,
  CX,
  CY,
  CZ,
  DE,
  DJ,
  DK,
  DM,
  DO,
  DZ,
  EC,
  EE,
  EG,
  EH,
  ER,
  ES,
  ET,
  FI,
  FJ,
  FK,
  FM,
  FO,
  FR,
  GA,
  GB,
  GD,
  GE,
  GF,
  GG,
  GH,
  GI,
  GL,
  GM,
  GN,
  GP,
  GQ,
  GR,
  GS,
  GT,
  GU,
  GW,
  GY,
  HK,
  HM,
  HN,
  HR,
  HT,
  HU,
  ID,
  IE,
  IL,
  IM,
  IN,
  IO,
  IQ,
  IR,
  IS,
  IT,
  JE,
  JM,
  JO,
  JP,
  KE,
  KG,
  KH,
  KI,
  KM,
  KN,
  KP,
  KR,
  KW,
  KY,
  KZ,
  LA,
  LB,
  LC,
  LI,
  LK,
  LR,
  LS,
  LT,
  LU,
  LV,
  LY,
  MA,
  MC,
  MD,
  ME,
  MF,
  MG,
  MH,
  MK,
  ML,
  MM,
  MN,
  MO,
  MP,
  MQ,
  MR,
  MS,
  MT,
  MU,
  MV,
  MW,
  MX,
  MY,
  MZ,
  NA,
  NC,
  NE,
  NF,
  NG,
  NI,
  NL,
  NO,
  NP,
  NR,
  NU,
  NZ,
  OM,
  PA,
  PE,
  PF,
  PG,
  PH,
  PK,
  PL,
  PM,
  PN,
  PR,
  PS,
  PT,
  PW,
  PY,
  QA,
  RE,
  RO,
  RS,
  RU,
  RW,
  SA,
  SB,
  SC,
  SD,
  SE,
  SG,
  SH,
  SI,
  SJ,
  SK,
  SL,
  SM,
  SN,
  SO,
  SR,
  SS,
  ST,
  SV,
  SX,
  SY,
  SZ,
  TC,
  TD,
  TF,
  TG,
  TH,
  TJ,
  TK,
  TL,
  TM,
  TN,
  TO,
  TR,
  TT,
  TV,
  TW,
  TZ,
  UA,
  UG,
  UM,
  US,
  UY,
  UZ,
  VA,
  VC,
  VE,
  VG,
  VI,
  VN,
  VU,
  WF,
  WS,
  XK,
  YE,
  YT,
  ZA,
  ZM,
  ZW,

  // Kontinente
  AFR,
  ASI,
  AUS,
  EUR,
  NAM,
  SAM,
};

const Icon: React.FC<IconProps> = ({
  name,
  size = 'default',
  color,
  margin = 'default',
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
  padding,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  style = {},
  className,
  onClick,
}) => {
  const IconComponent = ICON_COMPONENTS[name];
  
  // Größe bestimmen - Standard-Größen oder individuelle Werte
  const getIconSize = (): string => {
    if (typeof size === 'string' && ICON_SIZES[size as IconSize]) {
      // Standard-Größe verwenden (ICON_SIZES enthält number-Werte)
      return `${ICON_SIZES[size as IconSize]}px`;
    } else if (typeof size === 'number') {
      // Nummer als px-Wert behandeln
      return `${size}px`;
    } else if (typeof size === 'string') {
      // String direkt verwenden (für rem, em, %, etc.)
      return size;
    } else {
      // Fallback auf default (number zu string konvertieren)
      return `${ICON_SIZES.default}px`;
    }
  };
  
  // Margin bestimmen - Vordefinierte Werte oder direkte CSS-Werte
  const getIconMargin = (): string => {
    if (typeof margin === 'string' && ICON_MARGIN[margin as IconMargin]) {
      return ICON_MARGIN[margin as IconMargin];
    } else if (typeof margin === 'number') {
      return `${margin}px`;
    } else if (typeof margin === 'string') {
      return margin;
    } else {
      return ICON_MARGIN.default;
    }
  };

  // Hilfsfunktion um CSS-Werte zu normalisieren
  const normalizeValue = (value: string | number | undefined): string | undefined => {
    if (value === undefined) return undefined;
    if (typeof value === 'number') return `${value}px`;
    return value;
  };

  // Individuelle Margin-Werte bestimmen
  const getMarginValues = () => {
    const baseMargin = getIconMargin();
    return {
      marginTop: normalizeValue(marginTop) || baseMargin,
      marginRight: normalizeValue(marginRight) || baseMargin,
      marginBottom: normalizeValue(marginBottom) || baseMargin,
      marginLeft: normalizeValue(marginLeft) || baseMargin,
    };
  };
  
  // Padding bestimmen
  const getIconPadding = (): string | undefined => {
    if (typeof padding === 'number') {
      return `${padding}px`;
    } else if (typeof padding === 'string') {
      return padding;
    }
    return undefined;
  };

  // Individuelle Padding-Werte bestimmen
  const getPaddingValues = () => {
    const basePadding = getIconPadding();
    return {
      paddingTop: normalizeValue(paddingTop) || basePadding,
      paddingRight: normalizeValue(paddingRight) || basePadding,
      paddingBottom: normalizeValue(paddingBottom) || basePadding,
      paddingLeft: normalizeValue(paddingLeft) || basePadding,
    };
  };
  
  const iconSize = getIconSize();
  const marginValues = getMarginValues();
  const paddingValues = getPaddingValues();
  const iconColour = color || 'currentColor';

  if (!IconComponent) {
    logger.warn(`Icon "${name}" nicht gefunden.`);
    return null;
  }

  // CSS-Filter für spezielle Farben - Verbesserte Filter-Werte
  const getColorFilter = (color: string): string | undefined => {
    const colorFilters: { [key: string]: string } = {
      // Korrekte CSS-Filter für exakte Farben
      red: 'invert(20%) sepia(100%) saturate(4000%) hue-rotate(350deg) brightness(100%) contrast(100%)',
      blue: 'invert(35%) sepia(100%) saturate(2000%) hue-rotate(220deg) brightness(100%) contrast(100%)',
      green: 'invert(45%) sepia(100%) saturate(2000%) hue-rotate(120deg) brightness(100%) contrast(100%)',
      orange: 'invert(60%) sepia(100%) saturate(2000%) hue-rotate(25deg) brightness(100%) contrast(100%)',
      yellow: 'invert(80%) sepia(100%) saturate(2000%) hue-rotate(60deg) brightness(100%) contrast(100%)',
      gray: 'invert(50%) sepia(0%) saturate(0%)',
      black: 'invert(0%)',
      white: 'invert(100%)',
    };
    
    return colorFilters[color.toLowerCase()];
  };

  // Direkte Farbmapping für bessere Kontrolle
  const getDirectColor = (color: string): string | undefined => {
    const directColors: { [key: string]: string } = {
      red: '#ff0000',
      blue: '#0000ff', 
      green: '#00ff00',
      orange: '#ffa500',
      yellow: '#ffff00',
      gray: '#808080',
      black: '#000000',
      white: '#ffffff',
    };
    
    return directColors[color.toLowerCase()];
  };

  // CSS-Variablen-Unterstützung prüfen
  const isCSSVariable = color && color.startsWith('--');
  const directColor = color && !isCSSVariable ? getDirectColor(color) : undefined;
  const hasColorFilter = color && !isCSSVariable && !directColor && getColorFilter(color);

  const iconStyle: React.CSSProperties = {
    marginTop: marginValues.marginTop,
    marginRight: marginValues.marginRight,
    marginBottom: marginValues.marginBottom,
    marginLeft: marginValues.marginLeft,
    paddingTop: paddingValues.paddingTop,
    paddingRight: paddingValues.paddingRight,
    paddingBottom: paddingValues.paddingBottom,
    paddingLeft: paddingValues.paddingLeft,
    cursor: onClick ? 'pointer' : 'default',
    ...style, // Benutzer-definierte Styles haben Vorrang
  };

  let finalColor: string;

  if (directColor) {
    // Verwende direkte Farben für bessere Kontrolle
    iconStyle.color = directColor;
    finalColor = directColor;
  } else if (hasColorFilter) {
    // CSS-Filter als Fallback für komplexere Farben
    iconStyle.filter = getColorFilter(color);
    finalColor = 'currentColor';
  } else if (isCSSVariable) {
    // CSS-Variablen
    iconStyle.color = `var(${iconColour})`;
    finalColor = `var(${iconColour})`;
  } else {
    // Standard Farben (Hex, RGB, etc.)
    iconStyle.color = iconColour;
    finalColor = iconColour;
  }

  return (
    <IconComponent
      width={iconSize}
      height={iconSize}
      fill={finalColor}
      stroke={finalColor}
      color={finalColor}
      style={iconStyle}
      className={className}
      onClick={onClick}
    />
  );
};

export default Icon;
